import { Image } from "../Image";
import { ReactComponent as PlayIcon } from "../../assets/images/play.svg";

const Game = ({ imagesList, onClickImage, openIds, playGame, isPlayed, mode, width }) => {
	return (
		<div style={{ position: "relative" }} id="game_wrapper">
			{!isPlayed && (
				<button className="play-button" onClick={playGame}>
					<PlayIcon />
				</button>
			)}

			{imagesList?.map((rowList, index) => (
				<div
					style={{ display: "flex", pointerEvents: isPlayed ? "" : "none", opacity: isPlayed ? 1 : 0.4 }}
					key={index}>
					{rowList.map((image) => {
						return (
							<div style={{ padding: 2 }} key={image.id}>
								<Image
									onClick={onClickImage}
									isOpen={openIds[image.typeId]?.includes(image.id)}
									mode={mode}
									isPlayed={isPlayed}
									width={width}
									{...image}
								/>
							</div>
						);
					})}
				</div>
			))}
		</div>
	);
};

export default Game;
